APP_CONTAINER_VERSION = '12.39.16';
APP_CORE_VERSION = '12.42.15';
APP_CONTAINER_NAME = 'self-digital-fe';
APP_CORE_NAME = 'self-digital-core-fe';
